(function () {
  if (window.__queyaQuickshopInit) return;
  window.__queyaQuickshopInit = true;

  var overlay = document.getElementById('quickshop-overlay');
  var content = document.getElementById('quickshop-content');
  var closeBtn = document.getElementById('quickshop-close');
  if (!overlay || !content) return;

  var currentProduct = null;
  var selectedOptions = [];

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  function optionName(opt, idx) {
    if (typeof opt === 'string') return opt;
    if (opt && typeof opt === 'object' && opt.name) return opt.name;
    return 'Option ' + (idx + 1);
  }

  function findVariant(product, options) {
    return product.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === options[i]; });
    });
  }

  // Reconstruit le sheet à partir de currentProduct + selectedOptions (ne réinitialise JAMAIS la sélection)
  function renderAll() {
    var product = currentProduct;
    var variant = findVariant(product, selectedOptions);

    var html = '';
    html += '<div class="qs-top">';
    html += '<img class="qs-image" src="' + ((variant && variant.featured_image && (variant.featured_image.src || variant.featured_image)) || product.featured_image || '') + '" alt="">';
    html += '<div class="qs-info"><div class="qs-title">' + product.title + '</div><div class="qs-price">' + (variant ? money(variant.price) : '') + '</div></div>';
    html += '</div>';

    product.options.forEach(function (opt, idx) {
      var name = optionName(opt, idx);
      var values = [];
      product.variants.forEach(function (v) {
        if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
      });
      html += '<div class="qs-option"><div class="qs-option-label">' + name + '</div><div class="qs-option-values">';
      values.forEach(function (val) {
        var testOptions = selectedOptions.slice();
        testOptions[idx] = val;
        var matchingVariant = findVariant(product, testOptions);
        var available = matchingVariant ? matchingVariant.available : false;
        var selected = selectedOptions[idx] === val;
        html += '<button type="button" class="qs-pill' + (selected ? ' is-selected' : '') + (!available ? ' is-unavailable' : '') + '" data-option-index="' + idx + '" data-option-value="' + String(val).replace(/"/g, '&quot;') + '">' + val + '</button>';
      });
      html += '</div></div>';
    });

    var canAdd = variant && variant.available;
    html += '<button type="button" class="btn btn--secondary btn--wide qs-add" id="qs-add-btn"' + (canAdd ? '' : ' disabled') + '>';
    html += canAdd ? 'Ajouter au panier' : (variant ? 'Épuisé' : 'Sélectionne une option');
    html += '</button>';

    content.innerHTML = html;

    content.querySelectorAll('.qs-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = parseInt(pill.dataset.optionIndex, 10);
        selectedOptions[idx] = pill.dataset.optionValue;
        renderAll();
      });
    });

    var addBtn = document.getElementById('qs-add-btn');
    if (addBtn) addBtn.addEventListener('click', addToCart);
  }

  function addToCart() {
    var variant = findVariant(currentProduct, selectedOptions);
    if (!variant || !variant.available) return;
    var addBtn = document.getElementById('qs-add-btn');
    addBtn.disabled = true;
    addBtn.textContent = 'Ajout…';

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variant.id, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        closeSheet();
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = 'Réessayer';
      });
  }

  function openSheet(url) {
    overlay.classList.add('open');
    content.innerHTML = '<div class="qs-loading">Chargement…</div>';
    fetch(url + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        currentProduct = product;
        var firstAvailable = product.variants.find(function (v) { return v.available; }) || product.variants[0];
        selectedOptions = firstAvailable.options.slice();
        renderAll();
      })
      .catch(function () {
        content.innerHTML = '<div class="qs-loading">Impossible de charger le produit.</div>';
      });
  }

  function closeSheet() {
    overlay.classList.remove('open');
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-quickshop-open]');
    if (trigger) {
      evt.preventDefault();
      openSheet(trigger.getAttribute('data-quickshop-open'));
    }
  });

  closeBtn.addEventListener('click', closeSheet);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeSheet();
  });
})();